import React, { useContext, useRef, useEffect, useState } from 'react';
import axios from 'axios';
import logoHeader from '../Assets/Images/logo1.png';
import logoHeaderAlone from '../Assets/Images/YOUR-PACK_YP-G-COLOR.webp';
import { FaPeopleGroup, FaRegNewspaper } from 'react-icons/fa6';
import { TbDoorEnter } from 'react-icons/tb';
import { AiOutlineLogin } from 'react-icons/ai';
import { useHistory, Link } from 'react-router-dom';
import { useAtom, useSetAtom } from 'jotai';
import { resetTemporaryAtom, setTemporaryInitDashboardAtom } from '../Services/store/atoms';
import { logoutUserAtom, setCointAtom, toggleVisionUserModeAtom, isAuthAtom, dataUserAtom, coinsAtom, authUserAtom, visionUserModeAtom } from '../Services/store/atoms';
import { MdSpaceDashboard, MdSwitchAccount, MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md';
import { HiGlobeAlt } from 'react-icons/hi';
import { BsPersonHearts, BsPatchCheck, BsPatchExclamation, BsCloudUpload, BsShare } from 'react-icons/bs';
import { LuPackageSearch, LuPackageOpen, LuSearch, LuMonitorSmartphone, LuBell } from 'react-icons/lu';
import { PiCoinsDuotone, PiHeartbeatDuotone, PiPackageLight } from 'react-icons/pi';
import { ImProfile } from 'react-icons/im';
import { FcSalesPerformance } from 'react-icons/fc';
import { AiFillLike } from "react-icons/ai";
import { FaFlag, FaBan, FaUserSlash, FaImage } from 'react-icons/fa';
import Modal from '../Components/Modal';
import BellNotifications from '../Components/BellNotifications';
import useMediaQuery from '../hooks/useMediaQuery';
import config from '../Config';
import { BsMoonFill, BsSunFill } from 'react-icons/bs';
import DarkModeContext from '../Components/DarkModeContext';
import ShareProfileModal from '../Components/ShareProfileModal';

const getPublicLinks = () => [
    {
        title: 'Models',
        icon: <BsPersonHearts className='text-xl' />,
        url: '/',
        translate: 'no',
    },
    {
        title: 'Packs',
        icon: <LuPackageSearch className='text-xl' />,
        url: '/packs',
        translate: 'no',
    },
    {
        title: 'Feed Public',
        icon: <FaPeopleGroup className='text-xl' />,
        url: '/feed',
        translate: 'no',
    },
];

const getAuthLinks = (isAuth) => {
    if (!isAuth) {
        return [
            {
                title: 'Sign In',
                icon: <TbDoorEnter className='text-xl' />,
                url: '/login',
                translate: 'no',
                className: 'cursor-pointer block border-2 dark:text-white border-rose-400 text-gray-800 rounded-full p-1 -mt-1 flex flex-row border-1 border-rose-500 md:dark:hover:text-rose-400'
            },
            {
                title: 'Sign Up',
                icon: <AiOutlineLogin className='text-xl' />,
                url: '/register',
                translate: 'no',
                className: 'cursor-pointer block border-2 border-rose-400 text-gray-500 rounded-full p-1 -mt-1 flex flex-row border-1 border-rose-500 bg-rose-500 text-white'
            }
        ];
    }
    return [];
};

function Header() {
    const modalRef = useRef(null);
    const history = useHistory();
    const [isAuth] = useAtom(isAuthAtom);
    const [dataUser] = useAtom(dataUserAtom);
    const [coins] = useAtom(coinsAtom);
    const [authUser] = useAtom(authUserAtom);
    const [visionUserMode] = useAtom(visionUserModeAtom);
    const logoutUser = useSetAtom(logoutUserAtom);
    const setCoint = useSetAtom(setCointAtom);
    const toggleVisionUserMode = useSetAtom(toggleVisionUserModeAtom);
    const resetTemporary = useSetAtom(resetTemporaryAtom);
    const setTemporaryInitDashboard = useSetAtom(setTemporaryInitDashboardAtom);
    // Montar una sola campana a la vez (CSS oculta la otra pero seguiría haciendo polling)
    const isDesktop = useMediaQuery('(min-width: 768px)');
    const handleToggleVision = () => {
        const newVisionMode = !visionUserMode;
        console.log('handleToggleVision called', { newVisionMode, currentVisionMode: visionUserMode });
        axios.post('/api/v1/admin/toggle-view-as-user', { view_as_user: newVisionMode ? '1' : '0' }, {
            headers: { Authorization: `Bearer ${authUser?.token}` }
        })
        .then(response => {
            console.log('toggleViewAsUser success', response.data);
        })
        .catch(error => {
            console.error('toggleViewAsUser error', error);
        });
        toggleVisionUserMode();
        
        // Redirect based on vision mode
        if (!visionUserMode) {
            // Enabling vision mode - redirect to landing page to see as regular user
            history.push('/');
        } else {
            // Disabling vision mode - redirect back to admin dashboard
            history.push('/admin');
        }
    };
    const { darkMode, toggleDarkMode } = useContext(DarkModeContext);

    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
    const [shouldCloseOnOutsideClick, setShouldCloseOnOutsideClick] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [showShareModal, setShowShareModal] = useState(false);
    const [copied, setCopied] = useState(false);
    const [isUserPanelOpen, setIsUserPanelOpen] = useState(false);
    const userPanelRef = useRef(null);

    const publicLinks = getPublicLinks();
    const authLinks = getAuthLinks(isAuth && !visionUserMode);
    // Mismo criterio que el guard de RouteCheck: mientras falten estos datos
    // básicos, cualquier ruta privada de modelo redirige a
    // /model/complete-registration — así que ofrecer estos links en el menú
    // solo termina en un rebote. Se reemplazan por un único aviso no
    // clickeable en vez de mandarla a un callejón sin salida.
    const isModelProfileIncomplete = isAuth && dataUser.role === 'model' && (
        !dataUser?.name || !dataUser?.nickname || !dataUser?.phone ||
        !dataUser?.birthdate || dataUser?.birthdate === '2000-01-01'
    );
    const getRoleLinks = () => {
        if (!isAuth) return [];

        if (dataUser.role === 'model' && isModelProfileIncomplete) {
            return [{
                title: 'Completa tu perfil',
                icon: <ImProfile className='text-xl' />,
                disabled: true,
            }];
        }

        switch (dataUser.role) {
            case 'client':
                return [
                    {
                        title: 'Packs',
                        icon: <LuPackageOpen className='text-xl' />,
                        url: '/client/purchasedPacks',
                    },
                    {
                        title: 'Favorite Models',
                        icon: <PiHeartbeatDuotone className='text-xl' />,
                        url: '/client/favoriteModels',
                    },
                    {
                        title: 'Chat',
                        icon: <FaPeopleGroup className="text-xl" />,
                        url: '/chat',
                    },
                    {
                        title: 'Usuarios bloqueados',
                        icon: <FaBan className="text-xl" />,
                        url: '/client/blocked',
                    },
                ];
            case 'model':
                return [
                    {
                        title: 'Perfil Público',
                        icon: <ImProfile className='text-xl' />,
                        url: `/profileModal/${dataUser.id}`,
                    },
                    {
                        title: 'Compartir Perfil',
                        icon: <BsShare className='text-xl' />,
                        onClick: () => handlerShareProfile(),
                    },
                    {
                        title: 'Mi Muro',
                        icon: <FaRegNewspaper className='text-xl' />,
                        url: `/${dataUser.role}/feed`,
                        translate: 'no',
                    },
                    {
                        title: 'Subir Pack',
                        icon: <BsCloudUpload className='text-xl' />,
                        url: `/${dataUser.role}/uploadpack`,
                    },
                    {
                        title: 'Lista de Packs',
                        icon: <PiPackageLight className='text-xl' />,
                        url: `/${dataUser.role}/listpacks`,
                    },
                    {
                        title: 'Perfil',
                        icon: <PiPackageLight className='text-xl' />,
                        url: `/${dataUser.role}/profile`,
                    },
                    {
                        title: 'Ventas',
                        icon: <FcSalesPerformance className='text-xl' />,
                        url: `/${dataUser.role}/SalesModel`,
                    },
                    {
                        title: 'Cuentas Bancarias',
                        icon: <PiPackageLight className='text-xl' />,
                        url: `/${dataUser.role}/paymentMethods`,
                    },
                    {
                        title: 'Chat',
                        icon: <FaPeopleGroup className="text-xl" />,
                        url: '/chat',
                    },
                    {
                        title: 'Usuarios bloqueados',
                        icon: <FaBan className="text-xl" />,
                        url: `/${dataUser.role}/blocked`,
                    },
                ];
            case 'admin':
                return [
                    {
                        title: 'Cuentas por verificar',
                        icon: <MdSwitchAccount className='text-xl' />,
                        url: `/${dataUser.role}`,
                    },
                    {
                        title: 'Cuentas aprobadas',
                        icon: <BsPatchCheck className='text-xl' />,
                        url: `/${dataUser.role}/verifyApprove`,
                    },
                    {
                        title: 'Cuentas fallidas',
                        icon: <BsPatchExclamation className='text-xl' />,
                        url: `/${dataUser.role}/verifyFail`,
                    },
                    {
                        title: 'Packs por verificar',
                        icon: <LuPackageSearch className='text-xl' />,
                        url: `/${dataUser.role}/listpacksverify`,
                    },
                    {
                        title: 'Perfiles por verificar',
                        icon: <ImProfile className='text-xl' />,
                        url: `/${dataUser.role}/listprofilesverify`,
                    },
                    {
                        title: 'Ventas de Modelos',
                        icon: <FcSalesPerformance className='text-xl' />,
                        url: `/${dataUser.role}/modelsales`,
                    },
                    {
                        title: 'Reclamos del chat',
                        icon: <FaFlag className='text-xl' />,
                        url: `/${dataUser.role}/chat-claims`,
                    },
                    {
                        title: 'Alertas de bloqueo',
                        icon: <FaUserSlash className='text-xl' />,
                        url: `/${dataUser.role}/block-alerts`,
                    },
                    {
                        title: 'Imágenes bloqueadas',
                        icon: <FaImage className='text-xl' />,
                        url: `/${dataUser.role}/image-moderations`,
                    },
                    {
                        title: 'Minar likes',
                        icon: <AiFillLike  className='text-xl' />,
                        url: `/${dataUser.role}/FeedPublicFake`,
                    },
                    {
                        title: 'Bloqueo de Países',
                        icon: <HiGlobeAlt className='text-xl' />,
                        url: `/${dataUser.role}/countryBlocking`,
                    },
                    {
                        title: 'Buscar Modelos',
                        icon: <LuSearch className='text-xl' />,
                        url: `/${dataUser.role}/searchPacks`,
                    },
                    {
                        title: 'Chat',
                        icon: <FaPeopleGroup className="text-xl" />,
                        url: '/chat',
                    },
                ];
            case 'assistant':
                return [
                    {
                        title: 'Cuentas por verificar',
                        icon: <MdSwitchAccount className='text-xl' />,
                        url: `/${dataUser.role}`,
                    },
                    {
                        title: 'Perfiles por verificar',
                        icon: <ImProfile className='text-xl' />,
                        url: `/${dataUser.role}/listprofilesverify`,
                    },
                    {
                        title: 'Packs por verificar',
                        icon: <LuPackageSearch className='text-xl' />,
                        url: `/${dataUser.role}/listpacksverify`,
                    },
                    {
                        title: 'Cuentas aprobadas',
                        icon: <BsPatchCheck className='text-xl' />,
                        url: `/${dataUser.role}/verifyApprove`,
                    },
                    {
                        title: 'Chat',
                        icon: <FaPeopleGroup className="text-xl" />,
                        url: '/chat',
                    },
                ];
            default:
                return [];
        }
    };

    // Enlace global para toda cuenta autenticada, sin importar el rol (un perfil
    // de modelo incompleto rebota a completar registro, así que ahí no se ofrece).
    const sessionsLink = isAuth && !isModelProfileIncomplete ? [{
        title: 'Sesiones activas',
        icon: <LuMonitorSmartphone className='text-xl' />,
        url: `/${dataUser.role}/sessions`,
    }] : [];
    const notificationsSettingsLink = isAuth && !isModelProfileIncomplete ? [{
        title: 'Notificaciones',
        icon: <LuBell className='text-xl' />,
        url: `/${dataUser.role}/settings/notifications`,
    }] : [];
    const roleLinks = [...getRoleLinks(), ...sessionsLink, ...notificationsSettingsLink];

    useEffect(() => {
        if (isAuth && authUser?.token) {
            axios.defaults.headers.common.Authorization = `Bearer ${authUser.token}`;
            axios.get(`${config.REACT_APP_BASE_URL}/api/v1/coins`)
                .then(response => {
                    setCoint(response.data);
                })
                .catch(error => {
                    console.error('Error fetching coins:', error);
                });
        }
    }, [isAuth, authUser, setCoint]);

    const handlerCoins = () => {
        history.push('/client/rechargeCoins');
    };

    const handlerShareProfile = () => {
        setShowShareModal(true);
    };
    
    const navigate = (route) => {
        setTemporaryInitDashboard(true);
        history.push(route);
    };

    const logout = () => {
        logoutUser();
        resetTemporary();
        history.push('/');
    };

    const handleLogoutConfirmation = () => {
        setShowConfirmationModal(true);
    };

    const confirmLogout = () => {
        setShowConfirmationModal(false);
        logout();
    };

    const cancelLogout = () => {
        setShowConfirmationModal(false);
    };

    const toggleMobileMenu = () => {
        if (!mobileMenuVisible) {
            setShouldCloseOnOutsideClick(false);
            setTimeout(() => {
                setShouldCloseOnOutsideClick(true);
            }, 200);
        }
        setMobileMenuVisible(!mobileMenuVisible);
    };

    const handleClickOutside = (event) => {
        if (
            mobileMenuVisible &&
            shouldCloseOnOutsideClick &&
            !event.target.closest('.mobile-menu') &&
            !event.target.closest('.menu-button')
        ) {
            setMobileMenuVisible(false);
            setShouldCloseOnOutsideClick(false);
        }
    };

    useEffect(() => {
        if (mobileMenuVisible) {
            document.addEventListener('click', handleClickOutside);
        } else {
            document.removeEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [mobileMenuVisible, shouldCloseOnOutsideClick]);

    useEffect(() => {
        return () => {
            document.removeEventListener('mousemove', () => {});
        };
    }, []);

    return (
        <>
            {/* Header */}
            <nav className={`bg-white dark:bg-gray-900 text-black dark:text-white shadow-lg fixed top-0 w-full z-40`}>
                <div className="container mx-auto px-4">
                    <div className="flex items-center justify-between py-2 md:py-4 relative">
                        {/* Bell + Coins siempre visible en móvil */}
                        <div className="relative md:hidden flex items-center gap-2 mt-2">
                            {isAuth && (
                                <a onClick={() => handlerCoins()} className="cursor-pointer flex items-center gap-1 text-sm font-semibold text-rose-500 hover:text-rose-600" title="Coins">
                                    <PiCoinsDuotone className="text-lg" />
                                    <span>{coins}</span>
                                </a>
                            )}
                            {!isDesktop && <BellNotifications isAuth={isAuth} authUser={authUser} />}
                        </div>

                        {/* Logo Desktop */}
                        <a onClick={() => navigate('/')} aria-label="YourPack" className="relative cursor-pointer flex items-center font-robotoCondensed text-black dark:text-white text-3xl font-black">
                            <span aria-hidden="true" className="mt-2 pr-2 font-black" style={{ fontWeight: 900, textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)', color: darkMode ? '#ffffff' : '#000000' }} translate="no">YOUR</span>
                            <img src={logoHeaderAlone} width="96" height="96" className="absolute h-24 w-auto left-1/2 transform -translate-x-1/2" alt="" />
                            <span aria-hidden="true" className="mt-2 pl-10 ml-6 font-black" style={{ fontWeight: 900, textShadow: '2px 0px 1px rgba(0, 0, 0, 0.3)', color: darkMode ? '#ffffff' : '#000000' }} translate="no">PACK</span>
                        </a>

                        {/* Desktop Navigation */}
                        <div className="hidden md:flex items-center space-x-8">
                            {publicLinks.map((link, index) => (
                                <a
                                    key={index}
                                    onClick={() => navigate(link.url)}
                                    className="cursor-pointer block text-black dark:text-white rounded hover:text-rose-500 flex flex-row"
                                    aria-current="page"
                                    translate={link.translate}
                                >
                                    <div className="mt-1">{link.icon}</div>
                                    <div className="ml-1">{link.title}</div>
                                </a>
                            ))}

                            {isAuth && !visionUserMode && (
                                <>
                                    <a
                                        onClick={() => navigate('/' + dataUser.role)}
                                        className="cursor-pointer block border-2 border-rose-400 text-black dark:text-white hover:text-rose-500 rounded-full p-1 -mt-1 flex flex-row border-1 border-rose-500 md:dark:hover:text-rose-400 dark:text-white"
                                        aria-current="page"
                                        translate="no"
                                    >
                                        <div className="mt-1"><MdSpaceDashboard className="mr-1" /></div>
                                        <div>Dashboard</div>
                                    </a>
                                    {dataUser.role === 'admin' && (
                                        <button
                                            onClick={handleToggleVision}
                                            title={visionUserMode ? 'Ver como Admin' : 'Ver como Usuario'}
                                            className={`flex items-center gap-1 text-xs px-2 py-1 rounded font-semibold border transition-colors ${visionUserMode ? 'bg-rose-500 text-white border-rose-600' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 border-gray-300 dark:border-gray-600'}`}
                                        >
                                            {visionUserMode ? <MdOutlineVisibilityOff className='text-base' /> : <MdOutlineVisibility className='text-base' />}
                                            {visionUserMode ? 'Modo Usuario ON' : 'Modo Usuario'}
                                        </button>
                                    )}
                                    <a
                                        onClick={() => handlerCoins()}
                                        className="cursor-pointer block border-2 border-rose-400 text-black dark:text-white hover:text-rose-500 rounded-full p-1 -mt-1 flex flex-row border-1 border-rose-500 md:dark:hover:text-rose-400 dark:text-white"
                                        aria-current="page"
                                        translate="no"
                                    >
                                        <div className="mt-1"><PiCoinsDuotone className="mr-1" /></div>
                                        <div>{coins}</div>
                                    </a>
                                    {isDesktop && <BellNotifications isAuth={isAuth} authUser={authUser} />}
                                    <a
                                        onClick={handleLogoutConfirmation}
                                        className="cursor-pointer block border-2 border-rose-400 text-black dark:text-white hover:text-rose-500 rounded-full p-1 -mt-1 flex flex-row border-1 border-rose-500 md:dark:hover:text-rose-400 dark:text-white"
                                        aria-current="page"
                                        translate="no"
                                    >
                                        <div className="mt-1"><TbDoorEnter className="mr-1" /></div>
                                        <div>Logout</div>
                                    </a>
                                </>
                            )}
                            {isAuth && visionUserMode && (
                                <button
                                    onClick={handleToggleVision}
                                    title="Salir del modo usuario"
                                    className="flex items-center gap-1 text-xs px-2 py-1 rounded font-semibold border bg-rose-500 text-white border-rose-600 transition-colors"
                                >
                                    <MdOutlineVisibilityOff className='text-base' />
                                    Modo Usuario ON
                                </button>
                            )}
                            {!isAuth && authLinks.map((link, index) => (
                                <a
                                    key={index}
                                    onClick={() => navigate(link.url)}
                                    className={link.className}
                                    aria-current="page"
                                    translate={link.translate}
                                >
                                    <div className="mt-1">{link.icon}</div>
                                    <div className="ml-1">{link.title}</div>
                                </a>
                            ))}
                            <button
                                onClick={toggleDarkMode}
                                className="text-rose-500 hover:text-rose-700 focus:outline-none w-6 h-6"
                            >
                                {darkMode ? <BsSunFill /> : <BsMoonFill />}
                            </button>
                        </div>

                        {/* Mobile Menu Button */}
                        <div className="flex flex-row items-center space-x-2 block md:hidden lg:hidden">
                            <button
                                onClick={toggleMobileMenu}
                                className="text-rose-500 hover:text-rose-700 focus:outline-none menu-button w-6 h-6"
                            >
                                <svg
                                    className="w-6 h-6"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M4 6h16M4 12h16m-7 6h7"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </nav>

            {mobileMenuVisible && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-50" onClick={handleClickOutside}>
                    <div className="fixed top-0 left-0 h-full w-64 bg-white dark:bg-gray-900 shadow-lg transform transition-transform duration-300 ease-in-out mobile-menu z-70 overflow-y-auto">
                        <div className="h-full px-3 py-4 overflow-y-auto bg-white dark:bg-gray-900">
                            {/* Public Links Section */}
                            <div className="mb-6">
                                <h3 className="px-2 mb-3 text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase">
                                    Public Menu
                                </h3>
                                <ul className="space-y-2 font-medium">
                                    {publicLinks.map((link, index) => (
                                        <li key={index}>
                                            <a
                                                onClick={() => navigate(link.url)}
                                                className="block text-black dark:text-white rounded hover:bg-rose-500 hover:text-white p-2 flex flex-row"
                                                aria-current="page"
                                                translate={link.translate}
                                            >
                                                {link.icon} <span className="ml-2">{link.title}</span>
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Divider */}
                            <div className="my-4 border-t border-gray-200 dark:border-gray-700"></div>

                            {/* Auth Section */}
                            {!isAuth ? (
                                <div>
                                    <h3 className="px-2 mb-3 text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase">
                                        Account
                                    </h3>
                                    <ul className="space-y-2 font-medium">
                                        {authLinks.map((link, index) => (
                                            <li key={index}>
                                                <a
                                                    onClick={() => navigate(link.url)}
                                                    className="block text-black dark:text-white rounded hover:bg-rose-500 hover:text-white p-2 flex flex-row"
                                                    aria-current="page"
                                                    translate={link.translate}
                                                >
                                                    {link.icon} <span className="ml-2">{link.title}</span>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ) : (
                                <div>
                                    <ul className="space-y-2 font-medium">
                                        <li>
                                            <a
                                                onClick={() => navigate('/' + dataUser.role)}
                                                className="block text-black dark:text-white rounded hover:bg-rose-500 hover:text-white p-2 flex flex-row"
                                                aria-current="page"
                                                translate="no"
                                            >
                                                <MdSpaceDashboard className="mr-2" /><span>Dashboard</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                onClick={() => handlerCoins()}
                                                className="block text-black dark:text-white rounded hover:bg-rose-500 hover:text-white p-2 flex flex-row"
                                                aria-current="page"
                                                translate="no"
                                            >
                                                <PiCoinsDuotone className="mr-2" /><span>{coins}</span>
                                            </a>
                                        </li>

                                        {/* Role-specific links section */}
                                        {roleLinks.length > 0 && !visionUserMode && (
                                            <>
                                                <div className="my-4 border-t border-gray-200 dark:border-gray-700"></div>
                                                <h3 className="px-2 mb-3 text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase">
                                                    {dataUser.role.charAt(0).toUpperCase() + dataUser.role.slice(1)} Menu
                                                </h3>
                                                {roleLinks.map((link, index) => (
                                                    <li key={index}>
                                                        {link.disabled ? (
                                                            <span
                                                                className="block text-gray-400 dark:text-gray-500 p-2 flex flex-row cursor-not-allowed text-sm italic"
                                                            >
                                                                {link.icon} <span className="ml-2">{link.title}</span>
                                                            </span>
                                                        ) : link.onClick ? (
                                                            <button
                                                                onClick={link.onClick}
                                                                className="cursor-pointer block text-black dark:text-white rounded hover:bg-rose-500 hover:text-white p-2 flex flex-row w-full text-left"
                                                                aria-current="page"
                                                                translate={link.translate || 'yes'}
                                                            >
                                                                {link.icon} <span className="ml-2">{link.title}</span>
                                                            </button>
                                                        ) : (
                                                            <a
                                                                onClick={() => navigate(link.url)}
                                                                className="cursor-pointer block text-black dark:text-white rounded hover:bg-rose-500 hover:text-white p-2 flex flex-row"
                                                                aria-current="page"
                                                                translate={link.translate || 'yes'}
                                                            >
                                                                {link.icon} <span className="ml-2">{link.title}</span>
                                                            </a>
                                                        )}
                                                    </li>
                                                ))}
                                            </>
                                        )}

                                        {/* Vision mode exit button */}
                                        {isAuth && visionUserMode && (
                                            <li>
                                                <button
                                                    onClick={handleToggleVision}
                                                    className="cursor-pointer block text-rose-500 rounded hover:bg-rose-500 hover:text-white p-2 flex flex-row w-full text-left font-semibold"
                                                >
                                                    <MdOutlineVisibilityOff className="mr-2" />
                                                    <span>Salir del Modo Usuario</span>
                                                </button>
                                            </li>
                                        )}

                                        {/* Logout Link */}
                                        {!visionUserMode && (
                                            <li>
                                                <a
                                                    onClick={handleLogoutConfirmation}
                                                    className="block text-black dark:text-white rounded hover:bg-rose-500 hover:text-white p-2 flex flex-row"
                                                    aria-current="page"
                                                    translate="no"
                                                >
                                                    <TbDoorEnter className="mr-2" /><span>Logout</span>
                                                </a>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

          {/* Desktop Sidebar */}
{isAuth && ( // Solo se muestra si el usuario está autenticado
    <div
        ref={userPanelRef}
        className={`fixed top-0 left-0 h-full w-64 bg-white dark:bg-gray-900 shadow-lg transform transition-transform duration-300 ease-in-out ${
            isUserPanelOpen ? "translate-x-0" : "-translate-x-full"
        } z-40`}
    >
        <div
            className="absolute top-1/2 right-0 transform -translate-y-1/2
             translate-x-[120%] bg-rose-500 text-white px-3 py-4 rounded-r-lg 
             cursor-pointer rotate-90 origin-left uppercase hidden md:block 
             font-bold border-2 border-rose-200 "
            onClick={() => setIsUserPanelOpen(!isUserPanelOpen)}
        >
            MENU
        </div>

        <div className="h-full px-3 py-4 overflow-y-auto bg-white dark:bg-gray-900">
            {/* Role-specific links section */}
            {roleLinks.length > 0 && (
                <>
                    <h3 className="px-2 mb-3 text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase">
                        {dataUser.role.charAt(0).toUpperCase() + dataUser.role.slice(1)} Menu
                    </h3>
                    <ul className="list-none"> {/* Agrega la clase list-none aquí */}
                        {roleLinks.map((link, index) => (
                            <li key={index} className="list-none"> {/* Y también aquí */}
                                {link.disabled ? (
                                    <span
                                        className="block text-gray-400 dark:text-gray-500 p-2 flex flex-row cursor-not-allowed text-sm italic"
                                    >
                                        {link.icon} <span className="ml-2">{link.title}</span>
                                    </span>
                                ) : link.onClick ? (
                                    <button
                                        onClick={link.onClick}
                                        className="cursor-pointer block text-black dark:text-white rounded hover:bg-rose-500 hover:text-white p-2 flex flex-row w-full text-left"
                                        aria-current="page"
                                        translate={link.translate || 'yes'}
                                    >
                                        {link.icon} <span className="ml-2">{link.title}</span>
                                    </button>
                                ) : (
                                    <a
                                        onClick={() => navigate(link.url)}
                                        className="cursor-pointer block text-black dark:text-white rounded hover:bg-rose-500 hover:text-white p-2 flex flex-row"
                                        aria-current="page"
                                        translate={link.translate || 'yes'}
                                    >
                                        {link.icon} <span className="ml-2">{link.title}</span>
                                    </a>
                                )}
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    </div>
)}
            {/* Logout Confirmation Modal */}
            {showConfirmationModal && (
                <div className={`fixed inset-0 flex items-center justify-center z-confirm ${darkMode ? 'bg-gray-900 bg-opacity-75' : 'bg-white bg-opacity-75'}`}>
                    <div className={`bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg text-center ${darkMode ? 'text-white' : 'text-black'}`}>
                        <p className="mb-4">¿Estás seguro que deseas cerrar sesión?</p>
                        <div className="flex justify-center space-x-4">
                            <button
                                onClick={confirmLogout}
                                className={`px-4 py-2 rounded ${darkMode ? 'bg-rose-600 hover:bg-rose-700' : 'bg-rose-500 hover:bg-rose-600'} text-white`}
                            >
                                Cerrar Sesión
                            </button>
                            <button
                                onClick={cancelLogout}
                                className={`px-4 py-2 rounded ${darkMode ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-300 hover:bg-gray-400'} ${darkMode ? 'text-white' : 'text-black'}`}
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Coins Modal */}
            <Modal ref={modalRef} className="z-90" />

            {/* Share Profile Modal */}
            <ShareProfileModal
                isOpen={showShareModal}
                onClose={() => setShowShareModal(false)}
                nickname={dataUser?.nickname}
            />
        </>
    );
}

export default Header;